import { useEffect } from 'react';
import defaultBackground from '../../../pics/backgrounds/happyTavern.png';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import EditPositionDropdown from './EditPositionDropdown';
import EditTvTablePositionDropdown from './EditTvTablePositionDropdown';
import TvTableSizeToggle from './TvTableSizeToggle';
import ButtonMenu from './ButtonMenu';
import ToggleButton from './ToggleButton';

const PlayerViewBloodPreview = ({
        label, 
        type, 
        username, 
        currentEncounter, 

        parentObject, 
        setParentObject,

        playerOptions,
        setPlayerOptions,

        allyOptions,
        setAllyOptions,

        monsterOptions,
        setMonsterOptions,

        allPosition,
        setAllPosition,

        tableViewOptions,
        setTableViewOptions,

        socket,
}) => {

    useEffect(() => {
        let playerViewKey = type === 'global' ? 'playerViewGlobalOptions' : 'playerViewOptions'
        setParentObject(
            {...parentObject,
                [playerViewKey]: {
                    playerOptions: {...playerOptions},
                    monsterOptions: {...monsterOptions},
                    allyOptions: {...allyOptions},
                    tableViewOptions: {...tableViewOptions}
                }
            });
        // eslint-disable-next-line
    }, [playerOptions, monsterOptions, allyOptions, tableViewOptions]);

    useEffect(() => {
        if(playerOptions.position === monsterOptions.position && playerOptions.position === allyOptions.position) {
            setAllPosition(playerOptions.position)
        } else {
            setAllPosition('Mixed')
        }
    }, [playerOptions.position, monsterOptions.position, allyOptions.position])

    // visualKey can be 'showHp', 'showHpBar', 'showBlood', 'showDead', 'position', 'teamSize', 'showSize', 'deathSaves', 'showName'
    // creatureType can be 'monster' or 'player' or 'ally' or 'tableView'
    const handlePvOptionChange = (creatureType, visualKey, value) => {
        if(visualKey === 'teamSize' || visualKey === 'iconMargin' || visualKey === 'mapSize' || visualKey === 'gridSize') {
            value = handlePvSizeChange(creatureType, visualKey, value)
        } else if(visualKey === 'reset') {         // Table View Reset 
            // Reset by adding the opposite to get back to 0
            handlePvOptionChange('tableView', 'mapSize', parseInt(tableViewOptions.mapSize) * -1)
            handlePvOptionChange('tableView', 'teamSize', parseInt(tableViewOptions.teamSize) * -1)
            handlePvOptionChange('tableView', 'iconMargin', parseInt(tableViewOptions.iconMargin) * -1)
            handlePvOptionChange('tableView', 'gridSize', parseInt(tableViewOptions.gridSize) * -1)

            // return after everything is done so reset "reset" is not emitted
            return;
        }
        
        if(creatureType === 'all') {
            // If setting all, first set all then call this function again for each creature alignment
            setAllPosition(value)
            handlePvOptionChange('player', visualKey, value)
            handlePvOptionChange('monster', visualKey, value)
            handlePvOptionChange('ally', visualKey, value)
            return;
        } else if(creatureType === 'tableView') {
            setTableViewOptions(tvOps => { return {  
                ...tvOps,
                [visualKey]: value
            }})
        } else if(creatureType === 'player') {
            setPlayerOptions({  
                ...playerOptions,
                [visualKey]: value
            })
        } else if(creatureType === 'monster') {
            setMonsterOptions({
                ...monsterOptions,
                [visualKey]: value
            }) 
        } else if(creatureType === 'ally') {
            setAllyOptions({
                ...allyOptions,
                [visualKey]: value
            }) 
        } 

        if(type === 'global') {
            socket.emit("editPvGlobalOptions", creatureType, visualKey, value, username)
        } else {
            socket.emit("editPvOptions", creatureType, visualKey, value, parentObject.encounterGuid)
        }
    } 

    const handlePvSizeChange = (creatureType, visualKey, value) => {
        if(creatureType === 'player') {
            value += parseInt(playerOptions.teamSize)
        } else if(creatureType === 'ally') {
            value += parseInt(allyOptions.teamSize)
        } else if(creatureType === 'monster') {
            value += parseInt(monsterOptions.teamSize)
        } else if(creatureType === 'tableView') {
            let tableValue = parseInt(tableViewOptions[visualKey])
            if(visualKey === "gridSize" && (-3 === tableValue && value === -1))
                return

            value += tableValue
        }

        return value;
    } 

    const isBackgroundImage = !currentEncounter.backgroundGuid.includes("www.youtube.com")
      
    return (
        <div className='globalTypeOptions'>
            <Tabs>
                <div className='globalOptionsTitleContainer'>
                    <div className='globalTitle'>{type === 'global' ? <b>{label}</b> : <><i>'{currentEncounter.encounterName}' </i><b> {label}</b></>}</div>
                    <div className='globalTitleDesc'>{type === 'global' ? 'When \'Use Global\' is checked' : 'When \'Use Global\' is un-checked'}</div>
                    <div className='globalTitleDesc'>{type === 'global' ? 'Global Options will apply to all encounters': 'Each Encounter will apply its own options'}</div>
                </div>
                
                <TabList>
                    <Tab>Players</Tab>
                    <Tab>Allies</Tab>
                    <Tab>Enemies</Tab>
                </TabList>
                <div className='playerViewOptionsContainer'>
                    <div className='playerViewOptions background' style={{backgroundImage: isBackgroundImage ? `url(${currentEncounter.backgroundGuid})` : `url(${defaultBackground})`}}>
                        <div className="iconOptionsFlag"/>
                        <TabPanel key={'playerTab'}>
                            <ButtonMenu creatureType={'player'} options={playerOptions} currentEncounter={currentEncounter} handlePvOptionChange={handlePvOptionChange}/>
                        </TabPanel>
                        <TabPanel key={'allyTab'}>
                            <ButtonMenu creatureType={'ally'} options={allyOptions} currentEncounter={currentEncounter} handlePvOptionChange={handlePvOptionChange}/>
                        </TabPanel>
                        <TabPanel key={'monsterTab'}>
                            <ButtonMenu creatureType={'monster'} options={monsterOptions} currentEncounter={currentEncounter} handlePvOptionChange={handlePvOptionChange}/>
                        </TabPanel>
                    </div>
                </div>
            </Tabs>           
            <Tabs>
                <TabList>
                    <Tab>PlayerView</Tab>
                    <Tab>Tv-Table View</Tab>
                </TabList>
                <TabPanel key={'playerViewTab'}>
                    <div className='viewTypeOptions'>
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center', height: '60px'}}>
                            <div className='pVChecks' style={{position: 'relative'}}> 
                                <div style={{textUnderlineOffset: '3px', textDecoration: 'underline', textDecorationColor: '#881810ff'}}>
                                    <b>All Icons</b>
                                </div>
                                <EditPositionDropdown creatureType={'all'} current={allPosition} handlePvOptionChange={handlePvOptionChange}/>
                            </div>

                            
                        </div>

                        <div style={{display: 'flex', flexDirection: 'column', gap: '5px'}}>
                            <div className='pVChecks pVCheckLeft' style={{position: 'relative'}}> 
                                <b>Players </b>
                                {parseInt(playerOptions.teamSize) !== 0 && 
                                    <span  style={{fontSize: '11px', color: 'black'}}>
                                        (<b>{playerOptions.teamSize}</b><span style={{fontSize: '9px'}}>x</span>) 
                                    </span>
                                }
                                <EditPositionDropdown creatureType={'player'} current={playerOptions.position} handlePvOptionChange={handlePvOptionChange}/>
                            </div>
                            <div className='pVChecks pVCheckLeft' style={{position: 'relative'}}> 
                                <b>Allies </b>
                                {parseInt(allyOptions.teamSize) !== 0 && 
                                    <span  style={{fontSize: '11px', color: 'black'}}>
                                        (<b>{allyOptions.teamSize}</b><span style={{fontSize: '9px'}}>x</span>) 
                                    </span>
                                }
                                <EditPositionDropdown creatureType={'ally'} current={allyOptions.position} handlePvOptionChange={handlePvOptionChange}/>
                            </div>
                            <div className='pVChecks pVCheckLeft' style={{position: 'relative'}}> 
                                <b>Enemies </b>
                                {parseInt(monsterOptions.teamSize) !== 0 && 
                                    <span  style={{fontSize: '11px', color: 'black'}}>
                                        (<b>{monsterOptions.teamSize}</b><span style={{fontSize: '9px'}}>x</span>) 
                                    </span>
                                }
                                <EditPositionDropdown creatureType={'monster'} current={monsterOptions.position} handlePvOptionChange={handlePvOptionChange}/>
                            </div>
                        </div>
                        
                    </div>
                </TabPanel>

                <TabPanel key={'tvTableView'}>
                    <div className='tvTableSelectionsContainer'>
                        <div className='tvTableSelectionItemsContainer'>
                            <div style={{display: 'grid', gridTemplateColumns: 'auto auto auto auto', alignItems: 'center', justifyItems: 'start'}}>
                                <TvTableSizeToggle label={'Table Icons'} tableViewKey={'teamSize'} currentSize={tableViewOptions.teamSize} handlePvOptionChange={handlePvOptionChange}/>
                                <TvTableSizeToggle label={'Icon Margin'}  tableViewKey={'iconMargin'} currentSize={tableViewOptions.iconMargin} handlePvOptionChange={handlePvOptionChange}/>
                                <TvTableSizeToggle label={'Map Size'} tableViewKey={'mapSize'} currentSize={tableViewOptions.mapSize} handlePvOptionChange={handlePvOptionChange}/>
                                <TvTableSizeToggle label={'Grid Size'} tableViewKey={'gridSize'} currentSize={tableViewOptions.gridSize} handlePvOptionChange={handlePvOptionChange} minMax={[-3,99]}/>
                            </div>


                            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '60px', gap: '2px', alignItems: 'center'}}>
                                <div className='pVChecks' style={{position: 'relative', flexDirection: 'column', gap: '5px'}}> 
                                    <div style={{textUnderlineOffset: '3px', textDecoration: 'underline', textDecorationColor: '#881810ff'}}>
                                        <b>Icon Positions</b>
                                    </div> 
                                    <EditTvTablePositionDropdown creatureType={'tableView'} currentSides={tableViewOptions.position.split(',')} handlePvOptionChange={handlePvOptionChange}/>
                                </div>
                                <ToggleButton side={1} creatureType={'tableView'} title={'Map Grid'} checked={tableViewOptions.showGrid} cKey={'showGrid'} handlePvOptionChange={handlePvOptionChange}/>
                            </div>
                            
                        </div>
                        
                        {(parseInt(tableViewOptions.gridSize) !== 0 || parseInt(tableViewOptions.teamSize) !== 0 || parseInt(tableViewOptions.iconMargin) !== 0 || parseInt(tableViewOptions.mapSize) !== 0) &&
                            <div style={{cursor: 'pointer', textWrap: 'nowrap', color: "#9c3a3aff"}} title="Reset Tv-Table View Options" onClick={() => handlePvOptionChange('tableView', 'reset', null)}>
                                <b>Reset Table</b>
                            </div>
                        }
                    </div>
                </TabPanel>
            </Tabs>
        </div>
    );
}

export default PlayerViewBloodPreview;